import React, { useState } from 'react'
import cx from 'classnames'
import style from './bankItem.module.scss'
import { StatusList } from '../../status/list/StatusList'
import { BankItemHeader } from '../itemHeader/BankItemHeader'
import { PropTypes } from 'prop-types'
import { PaymentStatus } from '../../../../resources/constants/PaymentStatus'
import { BankItemBody } from '../itemBody/BankItemBody'

const BankItem = ({ item, className, isLastBank = false, isFirstBank = false }) => {
	const [isExpanded, setExpanded] = useState(isFirstBank)

	const { bank, lastStatus, lastEmissionDate, history } = item || {}

	return (
		<div className={cx(className, style.bankItem, { [style.isLastBank]: isLastBank })}>
			<div className={cx(style.progressLine)} />
			<BankItemHeader
				lastEmissionDate={lastEmissionDate}
				logo={bank?.logo}
				lastStatus={lastStatus}
			/>
			<div className={cx(style.bodyContainer)}>
				<div className={cx(style.body)}>
					<BankItemBody
						item={item}
						hasHistory={history?.length > 0}
						isExpanded={isExpanded}
						onClick={() => setExpanded(!isExpanded)}
					/>
					<StatusList isExpanded={isExpanded} history={history} />
				</div>
			</div>
		</div>
	)
}

BankItem.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Is the bank that will appear first in the component. It is the last bank contacted */
	isLastBank: PropTypes.bool,
	/** Is the bank that will appear last in the component. It is the first bank contacted */
	isFirstBank: PropTypes.bool,
	item: PropTypes.shape({
		bank: PropTypes.shape({
			name: PropTypes.string,
			logo: PropTypes.string,
			location: PropTypes.shape({
				city: PropTypes.string,
				country: PropTypes.string
			})
		}),
		/** Current status, to select the text */
		lastStatus: PropTypes.oneOf(Object.keys(PaymentStatus)),
		/** Last status emitted by that partner */
		lastEmissionDate: PropTypes.string,
		/** First status emitted by that partner */
		firstEmissionDate: PropTypes.string,
		/** List of bank's status history */
		history: PropTypes.arrayOf(
			PropTypes.shape({
				paymentStatus: PropTypes.oneOf(Object.keys(PaymentStatus)),
				/** Date of the status */
				date: PropTypes.string
			})
		)
	})
}

export { BankItem }
